import $ from "jquery";
import apiFetch from "@wordpress/api-fetch";

const CLICKED_CLASS = "post-like--clicked";

const likeButton = function () {
  const button = $(this);

  button.off("click", toggleLike);
  button.on("click", toggleLike);
};

const toggleLike = async function (event) {
  event.preventDefault();
  const button = $(this);
  const id = button.data("id");
  const countWrapper = button.find(".post-like__count");
  const count = parseInt(countWrapper.html());

  if (id) {
    if (!button.hasClass(CLICKED_CLASS)) {
      const url = `/xixoio/v1/post/like/set/${id}`;
      try {
        await fetchLike(url);
        button.addClass(CLICKED_CLASS);
        countWrapper.html(count + 1);
      } catch (e) {
        console.error(e);
      }
    } else {
      const url = `/xixoio/v1/post/like/unset/${id}`;
      try {
        await fetchLike(url);
        button.removeClass(CLICKED_CLASS);
        countWrapper.html(count >= 1 ? count - 1 : count);
      } catch (e) {
        console.error(e);
      }
    }
  }
};

const fetchLike = async (url) => {
  await apiFetch({ path: url });
};

export const reloadScriptPostLikeButton = () => {
  const el = $(".post-like");

  el.each(likeButton);
};
reloadScriptPostLikeButton();
